<template>
  <footer class="oct-globalfooter" id="oct-globalfoote">
    <div class="oct-gf__content">
      <section class="oct-gf__row">
        <div class="oct-gf__section oct-gf__statement">
          <p class="oct-gf__statement-text">
            <a href="/">
              <svg viewBox="0 0 241 50" class="oct-icon__marph">
                <use xlink:href="#oct-icon__marph"></use>
              </svg>
            </a>
            <br>
            <br>
            Common ground for art today.<br>
            Expose your latest work. <br class="oct-gf__statement-text--large">
            Follow your next inspiration.
          </p>
        </div>

        <div class="oct-gf__section">
          <div class="oct-gf-directory__column">
            <div class="oct-gf-directory__header">
              <span class="oct-gf-directory__title">MENU</span>
            </div>

            <div class="oct-gf-directory__body">
              <ul class="oct-gf-directory__list">
                <li class="oct-gf-directory__list-item">
                  <a :href="`${domain}/artists`" class="oct-gf-directory__link">Artists</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a :href="`${domain}/artworks`" class="oct-gf-directory__link">Artworks</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a :href="`${domain}/spaces`" class="oct-gf-directory__link">Galleries & Museums</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a :href="`${domain}/exhibitions`" class="oct-gf-directory__link">Exhibitions</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a :href="`${domain}/pr`" class="oct-gf-directory__link">Press Releases</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a :href="`${domain}/about`" class="oct-gf-directory__link">About</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="oct-gf-directory__column">
            <div class="oct-gf-directory__header">
              <span class="oct-gf-directory__title">SUPPORT</span>
            </div>

            <div class="oct-gf-directory__body">
              <ul class="oct-gf-directory__list oct-gf-directory__list--ja">
                <li class="oct-gf-directory__list-item">
                  <a href="https://marph.tayori.com/q/marph-faq/" target="_blank" class="oct-gf-directory__link">FAQ</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a :href="`${domain}/terms-of-use`" class="oct-gf-directory__link">利用規約</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a :href="`${domain}/privacy-policy`" class="oct-gf-directory__link">プライバシ−ポリシー</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a href="https://prtimes.co.jp/" target="_blank" class="oct-gf-directory__link">運営会社</a>
                </li>
                <li class="oct-gf-directory__list-item">
                  <a href="https://marph.tayori.com/f/contact-us/" target="_blank" class="oct-gf-directory__link">お問い合わせ</a>
                </li>
                <!-- @event 'quit' -->
                <li class="oct-gf-directory__list-item">
                  <span
                    class="oct-gf-directory__link"
                    @click="$emit('quit')"
                    v-if="false && user && user.id"
                  >
                    退会する
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div class="oct-gf-directory__column">
            <div class="oct-gf-directory__header">
              <span class="oct-gf-directory__title">ACCOUNT</span>
            </div>

            <div class="oct-gf-directory__body">
              <ul class="oct-gf-directory__list">
                <li
                  class="oct-gf-directory__list-item"
                  v-if="!user || !user.id"
                >
                  <a :href="`${domain}/account/settings`" class="oct-gf-directory__link">Log in / Sign up</a>
                </li>
                <li
                  class="oct-gf-directory__list-item"
                  v-if="user && (user.type === 'artist' || user.type === 'gallery')"
                >
                  <a :href="`${domain}/account/dashboard`" class="oct-gf-directory__link">Mypage</a>
                </li>
                <li
                  class="oct-gf-directory__list-item"
                  v-if="user && user.id"
                >
                  <a :href="`${domain}/account/saves-follows`" class="oct-gf-directory__link">Saves & Follows</a>
                </li>
                <!--
                <li
                  class="oct-gf-directory__list-item"
                  v-if="user && user.type === 'user'"
                >
                  <a :href="`${domain}javascript:void(0)`" class="oct-gf-directory__link">Convert to Artist / Gallery</a>
                </li>
                -->
                <li class="oct-gf-directory__list-item" role="separator">
                  &nbsp;
                </li>
                <li
                  class="oct-gf-directory__list-item"
                  v-if="user && user.id"
                >
                  <a :href="`${domain}/account/settings`" class="oct-gf-directory__link">Settings</a>
                </li>
                <li
                  class="oct-gf-directory__list-item"
                  v-if="user && user.id"
                >
                  <!-- @event 'signout' -->
                  <span
                    class="oct-gf-directory__link"
                    @click="$emit('signout')"
                  >
                    Log out
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="oct-gf__row">
        <div class="oct-gf__section">
          <ul class="oct-gf-social-list">
            <li class="oct-gf-social-list__item">
              <oct-icon-button icon="instagram" type="primary" size="small" href="https://www.instagram.com/marphcom/" target="_blank" />
            </li>
          </ul>
        </div>

        <div class="oct-gf__section">
          <div class="oct-gf__copyright">
            <p class="oct-gf__copyright-text">Copyright © PR TIMES Inc. 2022</p>
          </div>
        </div>
      </section>
    </div>
  </footer>
</template>

<script>
import OctIconButton from '@/components/icon-button/OctIconButton.vue';

export default {
  name: 'OctGlobalfooter',
  components: { OctIconButton },
  props: {
    /** User logged in  */
    user: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    /** GEt account type string */
    accountType () {
      // Invalid user
      if (!this.user) return ''

      return this.user.type === 'user' ? 'Personal' : this.user.type
    },
    /** Domain */
    domain () {
      return /^(marph\.com|stg\.marph\.com|localhost)$/.test(location.hostname) ? '' :
        'https://marph.com'
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-globalfooter {
  padding: oct-rem(72) oct-rem(20);
  background-color: $oct-theme--on-primary;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  padding: oct-rem(112) oct-rem(40);
}
}

.oct-gf__content {
}

.oct-gf__row {
  display: flex;
  flex-wrap: wrap;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0 oct-rem(-12) oct-rem(72);

  &:last-child {
    align-items: center;
    margin-bottom: 0;
  }
}
}

.oct-gf__section {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 0 oct-rem(12);
}
}

.oct-gf-directory__column {
  flex: 0 0 50%;

  &:last-child {
    flex: 0 0 100%;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0;
  flex: 0 0 (100%/3);
  max-width: (100%/3);
  padding: 0 oct-rem(4);

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
}
}

.oct-gf__statement {
  margin: 0 0 oct-rem(72);

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0;
  padding-right: oct-rem(80+12);
}
}

.oct-gf__statement-text {
  font-family: $font-family-sans-serif;
  font-size: oct-rem(26);
  line-height: (30/26);
  letter-spacing: -.002em;
  margin: (-5em/26) 0;
  display: block;

  .oct-icon__marph {
    width: oct-rem(96);
    height: oct-rem(20);
  }

  &--large {
    display: none;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(34);
  line-height: (36/34);
  letter-spacing: -.001em;
  margin: (-5em/24) 0;

  .oct-icon__marph {
    width: oct-rem(125);
    height: oct-rem(26);
  }

  &--large {
    display: initial;
  }
}
}

.oct-gf-directory__header {
  margin: 0 0 oct-rem(32);
  display: flex; // fix margin

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(72);
}
}

.oct-gf-directory__title {
  font-family: $font-family-sans-serif;
  font-size: oct-rem(13);
  line-height: (18/13);
  margin: (-4em/13) 0;
  display: block;
  opacity: .55;
}

.oct-gf-directory__list {
  margin: 0 0 oct-rem(64)-3;
  padding: 0;
  list-style: none;
}

.oct-gf-directory__list-item {
  font-size: oct-rem(15);
  line-height: (18/15);
  margin: (-3em/15) 0 ((-3em+12)/15);

  .oct-gf-directory__list:not(.oct-gf-directory__list--ja) & {
    font-family: $font-family-sans-serif;
  }

  .oct-auth--su &--dashboard,
  .oct-auth--user &--dashboard {
    display: none;
  }

  .oct-auth--gallery &--conversion,
  .oct-auth--artist &--conversion {
    display: none;
  }
}

.oct-gf-directory__link {
  text-decoration: none;
  cursor: pointer;

  &, &:visited {
    color: $oct-theme--primary;
  }
}

.oct-gf__legal {
  position: relative;

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(35);
  display: flex;
  justify-content: space-between;
  padding: oct-rem(10)-1 0 0;
  border-top: oct-rem(.99) solid $oct-theme--primary-border;
}
}

.oct-gf-pipe {
  font-size: oct-rem(10);
  font-weight: 600;
  color: $oct-theme--secondary;
  line-height: 1;
  margin: 0 0 oct-rem(10);
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-weight: 300;
  color: $oct-theme--primary-variant;
  margin: 0;
  flex-wrap: nowrap;
}
}

.oct-gf-pipe__item {
  flex: 0 0 50%;
  border-top: oct-rem(.99) solid $oct-theme--secondary-border;
  box-sizing: border-box;

  &:nth-child(2n+1) {
    border-right: oct-rem(.99) solid $oct-theme--secondary-border;
  }

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  flex: 1 1 auto;
  border-top-width: 0;

  &:nth-child(2n+1) {
    border-right-width: 0;
  }

  &:after {
    content: " ｜ ";
    white-space: pre;
  }

  &:last-child:after {
    content: none;
  }
}
}

.oct-gf-pipe__link {
  color: $oct-theme--secondary;
  text-decoration: none;
  display: block;
  padding: oct-rem(15)oct-rem(-1) 0 oct-rem(15);

  .oct-gf-pipe__item:nth-child(2n) & {
    padding-left: oct-rem(15);
  }

  &[data-dismiss="account"] {
    opacity: 0.5;
    pointer-events: none;
  }

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  display: inline-block;
  padding: 0;

  .oct-gf-pipe__item:nth-child(2n) & {
    padding-left: 0;
  }
}
}

.oct-gf__logo {
  font-size: oct-rem(10);
  line-height: 1;
  position: absolute;
  fill: $oct-theme--secondary;
  right: oct-rem(20);
  left: 50%;
  bottom: 0;
  display: block;
  padding: oct-rem(15)-1 0 oct-rem(15) oct-rem(15);
  box-sizing: border-box;
  border-top: oct-rem(.99) solid $oct-theme--secondary-border;

  &:hover {
    fill: $oct-theme--primary;
  }

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  fill: $oct-theme--primary-variant;
  position: static;
  padding: 0;
  border-top-width: 0;
}
}

.oct-gf-social-list {
  margin: 0 0 oct-rem(24);
  display: flex;
  padding: 0;
  list-style: none;

  .oct-icon-button {
    margin-right: oct-rem(10);
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: 0;
}
}

.oct-gf__copyright-text {
  font-family: $font-family-sans-serif;
  font-size: oct-rem(13);
  line-height: (18/13);
  margin: (-4em/13) 0;
  display: block;
  opacity: .55;
}
</style>
